/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import CustomBreadcrumb from '../../../common/bread-crumb/Breadcrumb';
import { useTranslation } from 'react-i18next';
import HrArrowRtl from '../../../assets/imgs/icons/horizontal-arrow-rtl.png';
import HrArrowLtr from '../../../assets/imgs/icons/horizontal-arrow-ltr.png';
import { useContext, useEffect } from 'react';
import UserOrdersContext from '../../../contexts/user-orders-context/UserOrdersContext';
import UserOrderCard from './UserOrderCard';
import routerLinks from '../../../components/app/routerLinks';
import userRouterLinks from '../../../components/app/user-routes/uesRouterLinks';
import { Empty, Pagination } from 'antd';
import {
  useNavigate,
  useLocation,
  useParams,
  Link as RouterLink
} from 'react-router-dom';
import queryString from 'query-string';
import getAllUserOrdersApi from '../../../apis/user-orders-apis/getAllUserOrdersApi';
import useCustomApiRequest from '../../../custom-hooks/useCustomApiRequest';
import UserContext from '../../../contexts/user-context/UserProvider';
import checkRes from '../../../utils/checkRes';
import './UserOrdersPage.scss';
import LoadingModal from '../../../common/loading-modal/LoadingModal';
import accountTypes from '../../../const-values/accountTypes';
import merchentRouterLinks from '../../../components/app/merchent-routes/merchentRouterLinks';
import UserOrderReceiptModal from './UserOrderReceiptModal';
import AddressMapModal from './AddressMapModal';
import { orderStatusArr } from '../../../const-values/orderStatus';
import RateOrderModal from './RateOrderModal';

const UserOrdersPage = () => {
  const { user } = useContext(UserContext);
  const params = useParams();
  const {
    isLoadingOrders,
    setIsLoadingOrders,
    isRating,
    ordersFilter,
    fetchOrdersCount,
    rateModalOpened,
    allFetchedOrders,
    setAllFetchedOrders,
    setOrdersPagination,
    isCancelling,
    setFetchOrdersCount,
    receiptModalOpened,
    addressMapModalOpened,
    ordersPagination
  } = useContext(UserOrdersContext);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { search } = useLocation();
  const values = queryString.parse(search);

  const customApiRequest = useCustomApiRequest();
  //
  // select request user or merchent
  const chooseRequest = () => {
    customApiRequest(
      getAllUserOrdersApi(
        {
          ...ordersFilter,
          ...values
        },
        user?.token,
        i18n.language
      ),
      (res) => {
        window.scrollTo(0, 0);
        setIsLoadingOrders(false);
        if (checkRes(res) && res.data?.data?.data?.length >= 0) {
          const data = res.data.data.data;
          setAllFetchedOrders(data);
          if (res.data.data?.pagination) {
            setOrdersPagination(res.data.data.pagination);
          }
        } else {
          setAllFetchedOrders(null);
        }
      },
      (error) => {
        setIsLoadingOrders(false);
      }
    );
  };

  //
  // select filter links user or merchent
  const selectFilterLinks = () => {
    return (
      <div className="filter-wrap">
        {orderStatusArr(user, t, {
          storeId: params?.storeId
        })?.length > 0 &&
          orderStatusArr(user, t, {
            storeId: params?.store_id
          }).map((obj) => {
            return (
              <RouterLink
                key={`${obj?.id}_key`}
                className={`filter-link ${i18n.dir()} ${
                  values?.status == obj?.status ? 'active-filter' : ''
                }`}
                to={obj?.url || '/'}
              >
                {obj?.name}
              </RouterLink>
            );
          })}
      </div>
    );
  };
  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      setIsLoadingOrders(true);
      chooseRequest();
    }

    return () => {
      isMounted = false;
    };
  }, [i18n.language, fetchOrdersCount, ordersFilter, search]);

  const renderPageContent = () => {
    if (isLoadingOrders && fetchOrdersCount === 0) {
      return (
        <div
          style={{
            display: 'grid',
            placeItems: 'center',
            padding: '132px 0',
            margin: '32px auto'
          }}
        >
          {/* <LoadingOutlined /> */}
          <LoadingModal />
        </div>
      );
    } else if (allFetchedOrders?.length === 0)
      return (
        <div className="custom-cotainer">
          <div
            style={{
              display: 'grid',
              padding: '52px 22px'
            }}
          >
            <Empty description={false}>You don't have any orders yet !!!</Empty>
          </div>
        </div>
      );
    else if (allFetchedOrders?.length > 0)
      return (
        <>
          <ul className="orders-ul">
            {allFetchedOrders.map((card) => (
              <UserOrderCard key={card?.id} card={card} />
            ))}
          </ul>

          {ordersPagination?.total > 0 && (
            <Pagination
              locale={{
                jump_to: i18n?.language === 'ar' ? 'إذهب إلى' : 'Go to',
                // page: i18n?.language === 'ar' ? 'الصفحة' : 'Page'
                page: ''
              }}
              showSizeChanger={false}
              defaultCurrent={1}
              current={ordersPagination.current_page}
              pageSize={ordersPagination.per_page}
              total={ordersPagination.total}
              // itemRender={itemRender}
              onChange={(page, pageSize) => {
                setFetchOrdersCount((prev) => prev + 1);
                navigate(
                  `${userRouterLinks?.myOrders}?status=${
                    values?.status || ''
                  }&page=${page}`
                );
              }}
              hideOnSinglePage={true}
            />
          )}
        </>
      );

    return null;
  };

  const sharedTrans = (key) => t(`userDashboard.${key}`);
  return (
    <div className="user-orders-page shared-dashboard-page shared-custom-page">
      <CustomBreadcrumb
        arr={[
          {
            title: sharedTrans('home'),
            isLink: true,
            to: routerLinks?.homePage
          },
          {
            title: sharedTrans('dashboard'),
            isLink: true,
            to:
              user?.accountType == accountTypes()?.user
                ? userRouterLinks?.userDashboard
                : merchentRouterLinks?.merchentDashboard
          },
          {
            title: t('ordersPage.title'),
            isLink: false
          }
        ]}
      />

      <div className="custom-container">
        <div className="title-arrow-wrap">
          <button
            onClick={() => {
              navigate(-1);
            }}
          >
            {i18n.dir() === 'rtl' ? (
              <img src={HrArrowRtl} alt="back" />
            ) : (
              <img src={HrArrowLtr} alt="back" />
            )}
          </button>
          <div className="main-page-title">{t('ordersPage.title')}</div>
        </div>
        <div className="page-body">
          {selectFilterLinks()}
          {renderPageContent()}
        </div>
      </div>

      {(isLoadingOrders || isRating || isCancelling) && <LoadingModal />}
      {receiptModalOpened && <UserOrderReceiptModal />}
      {rateModalOpened && <RateOrderModal />}
      {addressMapModalOpened && <AddressMapModal />}
    </div>
  );
};

export default UserOrdersPage;
